import { patchState, signalStore, type, withHooks, withMethods } from '@ngrx/signals';
import { addEntity, entityConfig, removeEntity, setAllEntities, setEntity, withEntities } from '@ngrx/signals/entities';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { exhaustMap, pipe, tap } from 'rxjs';
import { inject } from '@angular/core';
import { CertificateDto } from '@app/_api/dto';
import { CertificateApi } from '@app/core/services/certificate.api';
import { UUID } from '@app/_api/identifyable';
import { withAsyncInitialization } from '@app/pages/home/tree/store/feature/async-initialization.feature';

const config = entityConfig({
  entity: type<CertificateDto>(),
  selectId: c => c.uuid,
});

export const CertificateStore = signalStore(
  { providedIn: 'root' },
  withAsyncInitialization(),
  withEntities<CertificateDto>(config),
  withMethods((store, certificateApi = inject(CertificateApi)) => ({
    reloadAll: rxMethod<void>(
      pipe(
        exhaustMap(() => certificateApi.getAllCertificates()),
        tap(allCertificates => patchState(store, setAllEntities(allCertificates, config))),
      ),
    ),

    reloadById: rxMethod<UUID>(
      pipe(
        exhaustMap(id => certificateApi.getById(id)),
        tap(certificate => patchState(store, setEntity(certificate, config))),
      ),
    ),

    update(dto: CertificateDto) {
      patchState(store, setEntity(dto, config));
    },

    removeById(certificateId: UUID) {
      patchState(store, removeEntity(certificateId));
    },

    addCertificate(certificate: CertificateDto) {
      patchState(store, addEntity(certificate, config));
    },
  })),
  withHooks({
    onInit(store) {
      store.reloadAll();
    },
  }),
);
